(function () {
  'use strict';

  /* @ngdoc object
   * @name ajuntaments.newAjuntament
   * @description
   *
   */
  angular
  .module('neo.home.ajuntaments.newAjuntament', [
    'ui.router',
    'ngMaterial'
  ]);
}());
